import PageContainer from '@/common/components/PageContainer'
import { PermissionType } from '@/common/types'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import TrueWalletLogsListing from '@/modules/transaction/components/TrueWalletLogsListing'

function TrueWalletLogsPage() {
	return (
		<PageContainer>
			<div className="flex-1 space-y-4">
				<TrueWalletLogsListing />
			</div>
		</PageContainer>
	)
}

const GuardedTrueWalletLogsPage = withUserPermission(TrueWalletLogsPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_BANK_TRANSACTION],
})

export default GuardedTrueWalletLogsPage
